import React from 'react';
import styles from './TermsPage.module.css';

export default function TermsPage() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Terms of Service</h1>
        <p className={styles.date}>Last updated: March 2026</p>
      </div>
      <div className={styles.content}>
        <section className={styles.section}>
          <h2>Acceptance of Terms</h2>
          <p>By using beryl, you agree to these Terms of Service. If you do not agree, please stop using the app.</p>
        </section>
        <section className={styles.section}>
          <h2>Use of the App</h2>
          <p>beryl is provided for personal, non-commercial use to help track your injury recovery. You may not reverse-engineer, redistribute, or use the app for any unlawful purpose.</p>
        </section>
        <section className={styles.section}>
          <h2>No Medical Advice</h2>
          <p>beryl is a personal tracking tool only. Nothing in the app constitutes medical advice, diagnosis, or treatment. Always seek the advice of a qualified healthcare provider for any medical concerns.</p>
        </section>
        <section className={styles.section}>
          <h2>Your Content</h2>
          <p>You own all data you enter into beryl. By using the app, you grant us a limited licence to store and display your data back to you within the app.</p>
        </section>
        <section className={styles.section}>
          <h2>Limitation of Liability</h2>
          <p>beryl is provided "as is" without warranties of any kind. We are not liable for any loss or damage arising from your use of the app, including any reliance on information displayed within it.</p>
        </section>
        <section className={styles.section}>
          <h2>Changes to Terms</h2>
          <p>We may update these terms from time to time. Continued use of the app after changes are posted constitutes your acceptance of the updated terms.</p>
        </section>
      </div>
    </div>
  );
}
